/* eslint-disable import/no-anonymous-default-export */
export default {
  RELEASE_EVENT_ALTA_MEDICA: 1,
  RELEASE_EVENT_FALLECIMIENTO: 2,
  RELEASE_EVENT_TRASLADO_INTERNO: 3,
  RELEASE_EVENT_TRASLADO_BLOQUEO: 4
}
